export function CalorieRing({ consumed = 0, goal = 2000, size = 232, stroke = 18 }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.min(1, goal > 0 ? consumed / goal : 0);
  const offset = circ * (1 - pct);
  const remaining = Math.max(0, Math.round(goal - consumed));
  const over = consumed > goal;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="calorie-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke="hsl(var(--muted))" strokeWidth={stroke}
        />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none"
          stroke={over ? "#C45A39" : "hsl(var(--primary))"}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-5xl font-display font-medium tracking-tight tabular-nums" data-testid="ring-consumed">
          {Math.round(consumed).toLocaleString()}
        </span>
        <span className="text-sm text-muted-foreground mt-0.5">/ {goal.toLocaleString()} kcal</span>
        <span
          className={`mt-3 text-xs font-semibold px-3 py-1 rounded-full ${
            over ? "bg-accent/10 text-accent" : "bg-primary/10 text-primary"
          }`}
        >
          {over ? `${Math.round(consumed - goal)} over` : `${remaining} left`}
        </span>
      </div>
    </div>
  );
}
